import { v4 as uuidv4 } from "uuid";
export class AssetTypePropertyModel {
    constructor() {
        this.id = uuidv4();
        this.assetTypeId = "";
        this.assetTypePropertyName = "";
        this.isMandatory = true;
        this.dataTypeId = "";
        this.controlTypeId = "";
        this.controlDataListId = uuidv4();
        this.controlDataListValue = [];
    }
}
export default class AssetTypeProperty extends AssetTypePropertyModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
